document.addEventListener("DOMContentLoaded", function () {
  const grid = document.querySelector("#product-grid");
  const loadMoreBtn = document.querySelector(".load-more-btn");
  const showLessBtn = document.querySelector(".show-less-btn");
  const countText = document.querySelector(".product-count-text");
  const visibleCountEl = document.querySelector(".visible-count");

  if (!grid || !loadMoreBtn || !countText || !visibleCountEl) return;

  const totalCount = parseInt(countText.dataset.total, 10);
  const initialCount = grid.children.length;

  function updateCount() {
    const visibleCount = grid.children.length;
    visibleCountEl.textContent = visibleCount > totalCount ? totalCount : visibleCount;
  }

  // Initial count
  updateCount();

  loadMoreBtn.addEventListener("click", function () {
    const nextUrl = loadMoreBtn.dataset.nextUrl;
    if (!nextUrl) return;

    loadMoreBtn.textContent = "Loading...";

    fetch(nextUrl)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newItems = doc.querySelectorAll("#product-grid li");

        newItems.forEach(item => {
          item.classList.add("loaded-item");
          grid.appendChild(item);
        });

        const newBtn = doc.querySelector(".load-more-btn");
        if (newBtn && newBtn.dataset.nextUrl) {
          loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
          loadMoreBtn.textContent = "Load More Gifts";
        } else {
          loadMoreBtn.style.display = "none";
        }

        showLessBtn.style.display = "inline-block";
        updateCount();
      });
  });

  showLessBtn.addEventListener("click", function () {
    const loadedItems = grid.querySelectorAll(".loaded-item");
    loadedItems.forEach(item => item.remove());

    loadMoreBtn.style.display = "inline-block";
    loadMoreBtn.textContent = "Load More Gifts";
    showLessBtn.style.display = "none";

    updateCount();

    grid.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});document.addEventListener("DOMContentLoaded", function(){

  const sticky = document.getElementById("mobileStickyATC");
  const stickyBtn = document.getElementById("mobileStickyBtn");
  const mainATC = document.querySelector('product-form [type="submit"]');

  if(!sticky || !stickyBtn || !mainATC) return;

  sticky.classList.remove("show");

  const SCROLL_TRIGGER = 150;

  function isMainATCVisible(){
    const rect = mainATC.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function handleSticky(){

    const currentScroll = window.scrollY;

    /* Not scrolled enough */
    if(currentScroll < SCROLL_TRIGGER){
      sticky.classList.remove("show");
      return;
    }

    /* If real ATC visible → hide sticky */
    if(isMainATCVisible()){
      sticky.classList.remove("show");
    } 
    else {
      sticky.classList.add("show");
    }

  }

  window.addEventListener("scroll", () => requestAnimationFrame(handleSticky));
  window.addEventListener("load", handleSticky);
  window.addEventListener("resize", handleSticky);

  stickyBtn.addEventListener("click", function(){
    mainATC.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  });

});

document.addEventListener("DOMContentLoaded", function(){

  const btn = document.getElementById("stickyFilterBtn");

  if(btn){
    btn.addEventListener("click", function(){

      const filterBtn = document.querySelector('.mobile-facets__open-wrapper');

      if(filterBtn){
        filterBtn.click();
      }

    });
  }

});
document.addEventListener("DOMContentLoaded", function(){

const drawer = document.getElementById("newsletterDrawer");
const openBtn = document.getElementById("openNewsletter");
const closeBtn = document.getElementById("closeNewsletter");
const overlay = document.getElementById("newsletterOverlay");

function openDrawer(){
drawer.classList.add("open");
document.body.style.overflow="hidden";
}

function closeDrawer(){
drawer.classList.remove("open");
document.body.style.overflow="";
}

openBtn.addEventListener("click", openDrawer);
closeBtn.addEventListener("click", closeDrawer);
overlay.addEventListener("click", closeDrawer);

document.addEventListener("keydown", function(e){
if(e.key === "Escape"){
closeDrawer();
}
});

/* CLOSE WHEN CLICK OUTSIDE PANEL */
document.addEventListener("click", function(e){

if(!drawer.classList.contains("open")) return;

const panel = document.querySelector(".newsletter-panel");

if(!panel.contains(e.target) && !e.target.closest("#openNewsletter")){
closeDrawer();
}

});

});